import axiosInstance from "../services/api";
import { cookieUtils } from "./cookieUtils";

function redactSensitive(value) {
  if (Array.isArray(value)) {
    return value.map(redactSensitive);
  }
  if (value && typeof value === "object") {
    return Object.entries(value).reduce((safe, [key, nestedValue]) => {
      if (/token|session|authorization|password/i.test(key)) {
        safe[key] = "[redacted]";
      } else {
        safe[key] = redactSensitive(nestedValue);
      }
      return safe;
    }, {});
  }
  return value;
}

export async function logToServer(level, message, extra = {}) {
  try {
    const context = {
      tenant_id: cookieUtils.getAuthValue("tenantid"),
      tenant_name: cookieUtils.getAuthValue("tenant"),
      user_id: cookieUtils.getAuthValue("userid"),
      route: window.location.pathname,
    };

    await axiosInstance.post(`/logs/frontend`,{
        level,
        message,
        extra: {
          ...context,
          ...redactSensitive(extra),
          "event.name": extra.eventName || extra["event.name"] || (String(level).toUpperCase() === "ERROR" ? "nova.frontend.error" : "nova.frontend.log"),
          "error.code": extra.errorCode || extra["error.code"] || "",
        },
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent,
      })
  } catch (err) {
    console.error("Failed to send log", err);
  }
}